/* eslint-disable no-param-reassign */
/* eslint-disable arrow-body-style */
/* eslint-disable no-empty */
import axios, { isAxiosError } from 'axios';
import qs from 'query-string';
import { EnumAppType } from 'constants/enum';
import { generateSignEntry } from '@shopee/web_enhance_sap';
import { filterQueryParams, isEmptyObject, isObject } from './utils';
import store from '../redux/store';

const needAddSecurityHeaderUrl = [
  CONFIG.API_NOW_SHIP,
];

class Request {
  constructor () {
    this.header = {
      'x-foody-client-id': '',
      'x-foody-client-type': 1,
      'x-foody-app-type': EnumAppType.NOW_SHARE_APP.id,
      'x-foody-client-version': '3.0.0',
      'x-foody-api-version': 1,
      'x-foody-client-language': 'vi',
      'x-foody-access-token': '',
    };
    this.request = axios.create({
      baseURL: CONFIG.API_NOW_SHIP,
      headers: { ...this.header },
    });
    this.request.interceptors.request.use(Request.injectConfigRequest);
    this.request.interceptors.request.use(Request.addSecurityRequestHeader);
  }

  static injectConfigRequest (config) {
    const state = store.getState();
    return {
      ...config,
      headers: {
        ...config.headers,
        'x-foody-client-language': state.app.language,
      },
    };
  }

  static async addSecurityRequestHeader (config) {
    const { url, data, method, params } = config;

    const isMatchUrl = needAddSecurityHeaderUrl.some((host) => {
      return url.startsWith(host);
    });
    if (!isMatchUrl) {
      return config;
    }

    let body = data;
    if (method.toLowerCase() === 'post' && isObject(data)) {
      try {
        body = JSON.stringify(data);
      } catch (error) {}
    }

    let requestUrl = url;
    // 如果有参数，也需要添加到 url 中
    if (!isEmptyObject(params)) {
      const queryString = qs.stringify(filterQueryParams(params));
      if (queryString.length > 0) {
        if (requestUrl[requestUrl.length - 1] === '?') {
          requestUrl += queryString;
        } else if (requestUrl.includes('?')) {
          requestUrl = `${requestUrl}&${queryString}`;
        } else {
          requestUrl = `${requestUrl}?${queryString}`;
        }
      }
    }

    const signature = generateSignEntry(requestUrl, body);

    Object.keys(signature || []).forEach((key) => {
      config.headers[key] = signature[key];
    });

    return config;
  }

  static resolveResponse (respAxios) {
    const { data: response } = respAxios;
    return response;
  }

  static resolveError (error) {
    if (isAxiosError(error) && error.response?.status >= 500) {
      return { result: 'server_error' };
    }
    throw error;
  }

  getNowShip (endpoint, params = {}, delay = 0) {
    return this.request
      .get(CONFIG.API_NOW_SHIP + endpoint, {
        params,
        headers: this.header,
      })
      .then((response) =>
        delay === 0
          ? response
          : new Promise((resolve) =>
            setTimeout(() => resolve(response), delay),
          ),
      )
      .then(Request.resolveResponse)
      .catch(Request.resolveError);
  }
}

const RequestAPI = new Request();

export default RequestAPI;
